/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EconomicPerformanceCalculationMode {
  Unknown = 0,
  NewCalculation = 10,
  RebuildUsingPreviousSelections = 20,
  RepriceExistingSelection = 30,
}
